import type { Role, RolesWithPermissions } from '../permissions.js';

export const onlineStatus: RolesWithPermissions[Role]['permissions']['onlineStatus'] = {
  create: (user, status) => {
    if (!status) return false;
    return status.userID === user._id;
  },
  modify: (user, status) => {
    if (!status) return false;
    return status.userID === user._id;
  },
  delete: (user, status) => {
    if (!status) return false;
    return status.userID === user._id;
  },
};
